import { useCallback } from "react";
import "../../internal/features/forms/middleware.js";
import "../../internal/features/forms/reducer.js";
import { selectCurrent, selectCurrentEntity, selectLoading, selectError } from "../../internal/features/forms/selectors.js";
import { useAppActions } from "../../internal/shared/lib/store/hooks/useAppActions.js";
import { useAppSelector } from "../../internal/shared/lib/store/hooks/useAppSelector.js";
function useCurrentForm() {
  const currentForm = useAppSelector(selectCurrent);
  const currentEntityForm = useAppSelector(selectCurrentEntity);
  const loading = useAppSelector(selectLoading);
  const error = useAppSelector(selectError);
  const {
    forms: { setValues, setValue, submitForm }
  } = useAppActions();
  const setFieldValue = useCallback(
    (fieldId, value) => {
      if (!currentForm) {
        return;
      }
      setValue({ formId: currentForm, id: fieldId, value });
    },
    [currentForm, setValue]
  );
  const setFieldsValues = useCallback(
    (fields) => {
      if (!currentForm) {
        return;
      }
      setValues({ formId: currentForm, fields });
    },
    [currentForm, setValues]
  );
  return {
    current: currentForm,
    data: currentEntityForm,
    loading,
    error,
    actions: {
      setFieldValue,
      setFieldsValues,
      submitForm
    }
  };
}
export {
  useCurrentForm
};
